export default __webpack_public_path__ + "static/media/web.0c89bccd.svg";